/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Input, Button, FallbackImage, Textarea } from 'components';
import { CloseIcon, UserIcon } from 'assets/icons';
import moment from 'moment';

type ModalProps = {
	file: File | null
	onClose: () => void
	modal_data: any;
}

const ModalRIF = ({ file, onClose, modal_data }: ModalProps) => {
  const { blob, form } = useModal(file);
  const [isPdf, setIsPdf] = useState(false);

  useEffect(() => {
	    if (blob && blob.startsWith('blob:')) {
	        fetch(blob)
	            .then(res => {
	                const type = res.headers.get('content-type');
	                setIsPdf(type === 'application/pdf');
	            })
	            .catch(() => setIsPdf(false));
	    }
	}, [blob]);

	return (
		<div id="modal-photo-data">
			<button className="close" onClick={onClose}>
				<img src={CloseIcon} alt="Close" />
			</button>

			<section>
				<p className="title">RIF</p>
				
				{
					isPdf ? (
						<div style={{
							width: '100%',
							height: '350px',
							overflow: 'hidden',
							border: '1px solid #ccc'
						}}>
							<iframe src={ blob } style={{ border: 'none', width: '100%', height: '406px', marginTop: '-56px' }} />
						</div>
					) : (
						<div className="photo-wrapper">
							<FallbackImage
								src={blob}
								placeholder={UserIcon}
								className="fb-img"
								placeholderClassName="fb-img-placeholder"
							/>
						</div>
					)
				}

				<div className="input-group">
					<Input
						label="N° de RIF"
						value={modal_data?.document}
						onChange={() => {}}
						disabled
					/>
					<Input
						label="Fecha de Inscripción"
						value={modal_data?.registration_date ? moment(modal_data?.registration_date).format('DD/MM/YYYY') : ''}
						onChange={() => {}}
						disabled
					/>
					<Input
						label="Fecha de Expiración"
						value={modal_data?.expiration_date ? moment(modal_data?.expiration_date).format('DD/MM/YYYY') : ''}
						onChange={() => {}}
						disabled
					/>
					<Input
						label="Razón Social"
						value={modal_data?.name}
						onChange={() => {}}
						disabled
					/>
					<Textarea
						label="Domicilio Fiscal"
						rows={2}
						value={modal_data?.address}
						onChange={() => {}}
						disabled
					/>
				</div>
			</section>

			<section className="actions">
				<Button className="back" color="primary flat rounded-full" onClick={onClose}>
					Volver
				</Button>
			</section>
		</div>
	)
}

const useModal = (file: File | null) => {
	const empty = {
		rif: '',
		created_at: '',
		expired_at: '',
		name: '',
		address: '',
	};

  const [blob, setBlob] = useState('');
  const [form, setForm] = useState(empty);

  const fetchData = () => {
    try {
      // Obtiene la información de la imagen
      setForm({
				rif: '22333444',
				created_at: '18-nov-2016',
				expired_at: '18-nov-2026',
				name: 'La trinidad',
				address: 'Av. principal de La trinidad Municipio Baruta Sector Sorocaima Edif. Torrijo. Apt 33a',
      });

    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
		if (file) {
      setBlob(URL.createObjectURL(file));
      fetchData();
    }
  }, [file]);

  return {
		blob,
		form,
  }
}

export default ModalRIF;
